import { useDataTable } from '@/hooks/use-data-table'
import { useMembersList } from '../hooks/use-members-list'
import { useDepartments } from '../hooks/use-departments'
import { usePermission } from '@/features/permissions/hooks/use-permission'
import { useMemberColumns } from './columns'
import { HrHeader } from './hr-header'
import { MembersTable } from './members-table'
import { useMemberParams } from './use-member-params'
import { PageLayoutContainer } from '@/components/page-layout'

const HrPage = () => {
	const canView = usePermission('hr.members.view')
	const { q, status } = useMemberParams()
	const { members, handleArchive } = useMembersList()
	const { departments } = useDepartments()

	const columns = useMemberColumns(departments)

	const { table } = useDataTable({
		data: members,
		columns,
		getRowId: row => row.id,
		meta: { archiveMember: handleArchive },
	})

	if (!canView) return null

	return (
		<PageLayoutContainer>
			<HrHeader />
			<MembersTable data={members} hasFilters={Boolean(q || status)} table={table} />
		</PageLayoutContainer>
	)
}

export { HrPage }
